import { useMediaQuery } from '#app/hooks/user-media-query.js'

export const useDesktop = () => {
	return useMediaQuery('(min-width: 1025px)')
}

export const useIsMoreThanTablet = () => {
	return useMediaQuery('(min-width: 770px)')
}

/**
 * Used for when you want to map the same unit in multiple different nodes, instead of manually inputting the same values, we unit map the correct value here.
 * @param mobile
 * @param phone
 * @param sm
 * @param md
 * @param lg
 * @param xl
 * @param twoxl
 */
export const useMediaQueryUnitMap = <T>(
	mobile: T,
	phone: T,
	sm: T,
	md: T,
	lg: T,
	xl: T,
	twoxl: T,
): T => {
	const options: T[] = [mobile, phone, sm, md, lg, xl, twoxl]
	const queries = [
		useMediaQuery('(max-width: 360px)'),
		useMediaQuery('(max-width: 450px)'),
		useMediaQuery('(min-width: 450px'),
		useMediaQuery('(min-width: 770px)'),
		useMediaQuery('(min-width: 1024px)'),
		useMediaQuery('(min-width: 1280px)'),
		useMediaQuery('(min-width: 1536px)'),
	]

	const index = queries.lastIndexOf(true)

	return (index === -1 ? options[0] : options[index]) ?? mobile
}
